import { render, staticRenderFns } from "./EmisionDatosGeneralesIndex.vue?vue&type=template&id=4ea6dc50&scoped=true"
import script from "./EmisionDatosGeneralesIndex.vue?vue&type=script&lang=js"
export * from "./EmisionDatosGeneralesIndex.vue?vue&type=script&lang=js"
import style0 from "./EmisionDatosGeneralesIndex.vue?vue&type=style&index=0&id=4ea6dc50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea6dc50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelContent})
